import React from "react";
import AuthWrapper1 from "../../newTestPreo/pages/authentication/AuthWrapper1";
import { Grid, Typography } from "@mui/material";

export default function EventThankYouPage() {
  return (
    <>
      <Grid
        container
        sx={{
          minHeight: "100vh",
          background:
            "linear-gradient(180deg, rgb(255, 246.42, 240.12) 0%, rgba(255, 246.42, 240.12, 0) 100%)",
        }}
      >
        <Grid
          item
          sx={{
            position: "absolute",
            left: 10,
            top: 10,
          }}
        >
          <img src="/Siec Logo.png" style={{ width: "200px" }} />
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            direction="column"
            sx={{
              minHeight: "calc(100vh - 60px)",
              p: { xs: 2, sm: 1 },
              mb: 0,
            }}
            spacing={2}
          >
            <Grid item xs={12} mb={3}>
              <img src="/accept.png" width="20px" height="80px" />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h1" sx={{fontSize:'50px', color:'black'}}>Thank You!</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography textAlign="center" sx={{fontSize:'20px', color:'black'}}>
                We’re excited to have you with us and look forward to a
                productive session!
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
